export enum FiatCurrency {
  CAD = 'CAD',
  USD = 'USD'
}
